/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { DisplayFromFHIRMarkdown } from "../../datatypeComponents/MarkdownEntry";
import { Table } from "semantic-ui-react";
import { DisplayFromFHIRReference } from "../../datatypeComponents/ReferenceEntry";
import CodeableConceptEntry, { DisplayFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import ExpandToAddOrEdit from "../../components/ExpandToAddOrEdit";
import StringEntry from "../../datatypeComponents/StringEntry";
import SEVCO, { statisticTypeCodeableConceptSet } from "../../dictionaries/SEVCO";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";

const M11EstimandEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed,
    index, setKeyedResourceState, containedResourceDictionary = {}
}) => {

    const [outcomeMeasureEntryState, setOutcomeMeasureEntryState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingOutcomeEntry = {
            name: "", type: "", description: "",
            endpoint: "", population: "", intervention: "", comparator: "",
            endpointDisplay: "", populationDisplay: "", interventionDisplay: "", comparatorDisplay: "",
            summaryMeasure: "", eventHandling: []
        };
        if (startingValue) {
            if (startingValue.extension) { startingOutcomeEntry.extension = startingValue.extension; }
            if (startingValue.name) { startingOutcomeEntry.name = startingValue.name; }
            if (startingValue.type) { startingOutcomeEntry.type = startingValue.type; }
            if (startingValue.description) { startingOutcomeEntry.description = startingValue.description; }
            if (startingValue.endpoint) {
                startingOutcomeEntry.endpoint = startingValue.endpoint;
                startingOutcomeEntry.endpointDisplay = startingValue.endpoint.display;
            }
            if (startingValue.population) {
                startingOutcomeEntry.population = startingValue.population;
                startingOutcomeEntry.populationDisplay = startingValue.population.display;
            }
            if (startingValue.intervention) {
                startingOutcomeEntry.intervention = startingValue.intervention;
                startingOutcomeEntry.interventionDisplay = startingValue.intervention.display;
            }
            if (startingValue.comparator) {
                startingOutcomeEntry.comparator = startingValue.comparator;
                startingOutcomeEntry.comparatorDisplay = startingValue.comparator.display;
            }
            if (startingValue.summaryMeasure) { startingOutcomeEntry.summaryMeasure = startingValue.summaryMeasure; }
            if (startingValue.eventHandling) { startingOutcomeEntry.eventHandling = startingValue.eventHandling; }
        }
        setOutcomeMeasureEntryState(JSON.parse(JSON.stringify(startingOutcomeEntry)));
    }, []);

    useEffect((() => {
        if (Object.keys(outcomeMeasureEntryState).length > 0) {
            let newOutcomeEntry = {};
            if (outcomeMeasureEntryState.extension) { newOutcomeEntry.extension = outcomeMeasureEntryState.extension; }
            if (outcomeMeasureEntryState.name) { newOutcomeEntry.name = outcomeMeasureEntryState.name; }
            if (outcomeMeasureEntryState.type && Object.keys(outcomeMeasureEntryState.type).length > 0) {
                newOutcomeEntry.type = outcomeMeasureEntryState.type;
            }
            if (outcomeMeasureEntryState.description) { newOutcomeEntry.description = outcomeMeasureEntryState.description; }
            if (outcomeMeasureEntryState.endpoint && Object.keys(outcomeMeasureEntryState.endpoint).length > 0) {
                newOutcomeEntry.endpoint = outcomeMeasureEntryState.endpoint;
            }
            if (outcomeMeasureEntryState.endpointDisplay) {
                if (!newOutcomeEntry.endpoint) {
                    newOutcomeEntry.endpoint = {};
                }
                newOutcomeEntry.endpoint.display = outcomeMeasureEntryState.endpointDisplay;
            }
            if (outcomeMeasureEntryState.population && Object.keys(outcomeMeasureEntryState.population).length > 0) {
                newOutcomeEntry.population = outcomeMeasureEntryState.population;
            }
            if (outcomeMeasureEntryState.populationDisplay) {
                if (!newOutcomeEntry.population) {
                    newOutcomeEntry.population = {};
                }
                newOutcomeEntry.population.display = outcomeMeasureEntryState.populationDisplay;
            }
            if (outcomeMeasureEntryState.intervention && Object.keys(outcomeMeasureEntryState.intervention).length > 0) {
                newOutcomeEntry.intervention = outcomeMeasureEntryState.intervention;
            }
            if (outcomeMeasureEntryState.interventionDisplay) {
                if (!newOutcomeEntry.intervention) {
                    newOutcomeEntry.intervention = {};
                }
                newOutcomeEntry.intervention.display = outcomeMeasureEntryState.interventionDisplay;
            }
            if (outcomeMeasureEntryState.comparator && Object.keys(outcomeMeasureEntryState.comparator).length > 0) {
                newOutcomeEntry.comparator = outcomeMeasureEntryState.comparator;
            }
            if (outcomeMeasureEntryState.comparatorDisplay) {
                if (!newOutcomeEntry.comparator) {
                    newOutcomeEntry.comparator = {};
                }
                newOutcomeEntry.comparator.display = outcomeMeasureEntryState.comparatorDisplay;
            }
            if (outcomeMeasureEntryState.summaryMeasure && Object.keys(outcomeMeasureEntryState.summaryMeasure).length > 0) {
                newOutcomeEntry.summaryMeasure = outcomeMeasureEntryState.summaryMeasure;
            }
            if (Array.isArray(outcomeMeasureEntryState.eventHandling) && outcomeMeasureEntryState.eventHandling.length > 0) {
                newOutcomeEntry.eventHandling = outcomeMeasureEntryState.eventHandling;
            }
            if (Object.keys(newOutcomeEntry).length > 0) {
                if (setResourceState) {
                    setResourceState(prevState => { return { ...prevState, [elementName]: newOutcomeEntry }; });
                } else if (setKeyedResourceState) {
                    setKeyedResourceState(prevState => {
                        let newObjectValue = prevState[index];
                        newObjectValue[elementName] = newOutcomeEntry;
                        return {
                            ...prevState,
                            [index]: newObjectValue
                        }
                    });
                }
            }
        }
    }), [outcomeMeasureEntryState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                {startingValue.name && <p><b>Outcome Name: </b>{startingValue.name}</p>}
                {startingValue.description &&
                    <div><b>Outcome Description: </b>
                        <DisplayFromFHIRMarkdown markdown={startingValue.description} />
                        <br /><br /></div>}
                <Table>
                    <Table.Header>
                        <Table.HeaderCell>Estimand Characteristic</Table.HeaderCell>
                        <Table.HeaderCell>Description</Table.HeaderCell>
                    </Table.Header>
                    <Table.Body>
                        {startingValue.population &&
                            <Table.Row>
                                <Table.Cell>Population</Table.Cell>
                                <Table.Cell><DisplayFromFHIRReference reference={startingValue.population}
                                    containedResourceJson={startingValue.population.reference && containedResourceDictionary[startingValue.population.reference]} /></Table.Cell>
                            </Table.Row>
                        }
                        {(startingValue.intervention || startingValue.comparator) &&
                            <Table.Row>
                                <Table.Cell>Treatment</Table.Cell>
                                <Table.Cell>
                                    {startingValue.intervention && <span><b>Intervention Group: </b><DisplayFromFHIRReference reference={startingValue.intervention}
                                        containedResourceJson={startingValue.intervention.reference && containedResourceDictionary[startingValue.intervention.reference]} /></span>}
                                    {(startingValue.intervention && startingValue.comparator) && <br />}
                                    {startingValue.comparator && <span><b>Comparator Group: </b><DisplayFromFHIRReference reference={startingValue.comparator}
                                        containedResourceJson={startingValue.comparator.reference && containedResourceDictionary[startingValue.comparator.reference]} /></span>}
                                </Table.Cell>
                            </Table.Row>
                        }
                        <Table.Row>
                            <Table.Cell>Endpoint</Table.Cell>
                            <Table.Cell>
                                {startingValue.endpoint ?
                                    <span><DisplayFromFHIRReference reference={startingValue.endpoint}
                                        containedResourceJson={startingValue.endpoint.reference && containedResourceDictionary[startingValue.endpoint.reference]} /></span>
                                    :
                                    <span>NO DATA. THIS IS REQUIRED.</span>}
                            </Table.Cell>
                        </Table.Row>
                        {startingValue.summaryMeasure &&
                            <Table.Row>
                                <Table.Cell>Population-level Summary</Table.Cell>
                                <Table.Cell>
                                    <DisplayFromFHIRCodeableConcept codeableConcept={startingValue.summaryMeasure} />
                                </Table.Cell>
                            </Table.Row>}
                        {(Array.isArray(startingValue.eventHandling) &&
                            startingValue.eventHandling.length) &&
                            <>
                                <Table.Row>
                                    <Table.Cell>Other Intercurrent Event</Table.Cell>
                                    <Table.Cell>Strategy</Table.Cell>
                                </Table.Row>
                                {startingValue.eventHandling.map((ice, iceIndex) => {
                                    let event = ice.event || "";
                                    let group = ice.group || "";
                                    let handling = ice.handling || "";
                                    let description = ice.description || "";
                                    return <Table.Row key={iceIndex}>
                                        <Table.Cell>
                                            {event && <span><b>Event: </b><DisplayFromFHIRCodeableConcept codeableConcept={event} /><br /></span>}
                                            {group && <span><b>Group: </b><DisplayFromFHIRCodeableConcept codeableConcept={group} /></span>}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {handling && <span><b>Handling: </b><DisplayFromFHIRCodeableConcept codeableConcept={handling} /><br /></span>}
                                            {description && <span><b>Description: </b><DisplayFromFHIRMarkdown markdown={description} /><br /></span>}
                                        </Table.Cell>
                                    </Table.Row>
                                })}
                            </>}
                    </Table.Body>
                </Table>
            </div>}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(outcomeMeasureEntryState).length > 0) {
        return <div>
            <b>{fieldLabel}: </b>
            <div style={{ marginLeft: "24px" }}>
                <h4>Enter a name or short label for the outcome measure. This will be used in the M11 Report Section 1 Protocol Summary.</h4>
                <StringEntry elementName='name' fieldLabel='Name'
                    startingValue={outcomeMeasureEntryState.name}
                    setResourceState={setOutcomeMeasureEntryState} />
                <h4>Enter a nontechnical (layperson) description for the outcome measure. If provided, this will be used in the M11 Report Section 1 Protocol Summary.</h4>
                <StringEntry elementName='description' fieldLabel='Description'
                    startCollapsed={startCollapsed}
                    startingValue={outcomeMeasureEntryState.description} setResourceState={setOutcomeMeasureEntryState} />
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell><b>Estimand Characteristic</b> </Table.HeaderCell>
                            <Table.HeaderCell><b>Description</b>  (Enter data here. Where you have the option to reference Resources, you can simply enter text.)</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell><b>Population (optional)</b> List of key characteristics, such as demographic characteristics and clinical characteristics</Table.Cell>
                            <Table.Cell>
                                <StringEntry elementName='populationDisplay' fieldLabel='Population'
                                    startingValue={outcomeMeasureEntryState.populationDisplay}
                                    setResourceState={setOutcomeMeasureEntryState} />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell><b>Treatment (optional)</b> List of key aspects of treatment regimens in each treatment group, including at least investigational agents, dosage, and administration route</Table.Cell>
                            <Table.Cell>
                                <span><b>Intervention Group: </b>
                                    <StringEntry elementName='interventionDisplay'
                                        fieldLabel='Intervention Group'
                                        startingValue={outcomeMeasureEntryState.interventionDisplay}
                                        setResourceState={setOutcomeMeasureEntryState} />
                                </span>
                                <br />
                                <span><b>Comparator Group: </b>
                                    <StringEntry elementName='comparatorDisplay' fieldLabel='Comparator Group'
                                        startingValue={outcomeMeasureEntryState.comparatorDisplay}
                                        setResourceState={setOutcomeMeasureEntryState} />
                                </span>
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell><b>Endpoint (REQUIRED)</b> Definition of the endpoint</Table.Cell>
                            <Table.Cell>
                                <StringEntry elementName='endpointDisplay' fieldLabel='Endpoint'
                                    required={true}
                                    startingValue={outcomeMeasureEntryState.endpointDisplay}
                                    setResourceState={setOutcomeMeasureEntryState} />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell><b>Population-level Summary (optional)</b>Desription of the population-level summary measure (e.g., mean of differences, relative risk)</Table.Cell>
                            <Table.Cell>
                                <CodeableConceptEntry elementName='summaryMeasure' fieldLabel='Summary Measure'
                                    valueSet={SEVCO.statisticType} codeableConceptLevelValueSet={statisticTypeCodeableConceptSet}
                                    startingValue={outcomeMeasureEntryState.summaryMeasure} setResourceState={setOutcomeMeasureEntryState} />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell><b>Handling of Intercurrent Events (optional)</b> If used, enter an event handling description for each event.</Table.Cell>
                            <Table.Cell>
                                <ArrayEntry datatype='EventHandling' elementName='eventHandling'
                                    fieldLabel='Handling of Intercurrent Events' doNotShowFieldLabel={true}
                                    startEmptyArrayClosed={true}
                                    startingValue={outcomeMeasureEntryState.eventHandling}
                                    setResourceState={setOutcomeMeasureEntryState} />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </div>
        </div>
    }
};

export default M11EstimandEntry;